export const WalletIcon = ({ className, color = "currentColor" }: { className?: string; color?: string }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.1667 5.50002V3.50002C14.1667 2.76364 13.5697 2.16669 12.8333 2.16669H3.5C2.39543 2.16669 1.5 3.06212 1.5 4.16669M1.5 4.16669C1.5 5.27126 2.39543 6.16669 3.5 6.16669H13.5C14.2364 6.16669 14.8333 6.76364 14.8333 7.50002V9.50002M1.5 4.16669V13.5C1.5 14.6046 2.39543 15.5 3.5 15.5H13.5C14.2364 15.5 14.8333 14.903 14.8333 14.1667V12.1667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 9.50002V12.1667H12.8333C11.7288 12.1667 10.8333 11.2713 10.8333 10.1667V10.1667C10.8333 9.06212 11.7288 8.16669 12.8333 8.16669H15.5V9.50002Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
